module.exports = __webpack_public_path__ + "static/media/jiechulaodonghetong1.fbeb054a.png";